import { ActionIcon, AppShell, Group, NavLink, Stack, Text, Tooltip, useMantineColorScheme } from '@mantine/core'
import {
  IconAffiliate,
  IconBook,
  IconChartBar,
  IconDatabase,
  IconHeartbeat,
  IconKey,
  IconLock,
  IconMoonStars,
  IconRobot,
  IconRoute,
  IconSitemap,
  IconSun,
  IconTimeline,
} from '@tabler/icons-react'
import { createFileRoute, Outlet, redirect, useLocation, useNavigate } from '@tanstack/react-router'

async function fetchUserProfile() {
  const res = await fetch('/api/users/me', { credentials: 'include' })
  if (!res.ok) return null
  return res.json()
}

export const Route = createFileRoute('/dev')({
  beforeLoad: async () => {
    const user = await fetchUserProfile()
    if (!user || user.role !== 'platform_admin' || !user.is_super_admin) {
      throw redirect({ to: '/login' })
    }
    return { user }
  },
  component: DevLayout,
})

const NAV_ITEMS = [
  { label: 'AI Flow', value: 'ai-flow', icon: <IconAffiliate size={18} stroke={1.5} />, to: '/dev/ai-flow' },
  { label: 'Agent Swarm', value: 'agent-swarm', icon: <IconRobot size={18} stroke={1.5} />, to: '/dev/agent-swarm' },
  { label: 'Code Graph', value: 'code-graph', icon: <IconSitemap size={18} stroke={1.5} />, to: '/dev/code-graph' },
  { label: 'DB Schema', value: 'db-schema', icon: <IconDatabase size={18} stroke={1.5} />, to: '/dev/db-schema' },
  {
    label: 'Observability',
    value: 'observability',
    icon: <IconChartBar size={18} stroke={1.5} />,
    to: '/dev/observability',
  },
  { label: 'AI Routing', value: 'ai-routing', icon: <IconRoute size={18} stroke={1.5} />, to: '/dev/ai-routing' },
  { label: 'API Keys', value: 'api-keys', icon: <IconKey size={18} stroke={1.5} />, to: '/dev/api-keys' },
  { label: 'Docs', value: 'docs', icon: <IconBook size={18} stroke={1.5} />, to: '/dev/docs' },
  {
    label: 'Evolusi Handler',
    value: 'handler-evolution',
    icon: <IconTimeline size={18} stroke={1.5} />,
    to: '/dev/handler-evolution',
  },
  {
    label: 'File Health',
    value: 'file-health',
    icon: <IconHeartbeat size={18} stroke={1.5} />,
    to: '/dev/file-health',
  },
  {
    label: 'WA Repair Budget',
    value: 'wa-repair-budget',
    icon: <IconLock size={18} stroke={1.5} />,
    to: '/dev/wa-repair-budget',
  },
]

function DevLayout() {
  const location = useLocation()
  const navigate = useNavigate()
  const { colorScheme, toggleColorScheme } = useMantineColorScheme()

  const activeValue = NAV_ITEMS.find((item) => location.pathname.startsWith(item.to))?.value

  return (
    <AppShell navbar={{ width: 220, breakpoint: 'sm' }} padding="md">
      <AppShell.Navbar p="xs">
        <Stack gap={4} style={{ flex: 1 }}>
          <Group px="xs" py="sm" justify="space-between">
            <Text fw={700} size="sm">
              Dev
            </Text>
            <Tooltip label={colorScheme === 'dark' ? 'Light mode' : 'Dark mode'}>
              <ActionIcon variant="subtle" size="sm" onClick={toggleColorScheme}>
                {colorScheme === 'dark' ? <IconSun size={14} /> : <IconMoonStars size={14} />}
              </ActionIcon>
            </Tooltip>
          </Group>
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.value}
              label={item.label}
              leftSection={item.icon}
              active={activeValue === item.value}
              onClick={() => navigate({ to: item.to as string })}
            />
          ))}
        </Stack>
        <NavLink
          label="Kembali ke Platform"
          leftSection={<Text size="xs">←</Text>}
          onClick={() => navigate({ to: '/platform' })}
          style={{ opacity: 0.6 }}
        />
      </AppShell.Navbar>
      <AppShell.Main>
        <Outlet />
      </AppShell.Main>
    </AppShell>
  )
}
